export const FIRST_NAME = 'Имя';
export const LAST_NAME = 'Фамилия';
export const AFTER_NANE = 'Отчество';
export const DATE_OF_BIRTH = 'Дата рождения*';
export const CITIZENSHIP = 'Гражданство';
export const PASSPORT = 'Серия и номер паспорта';
export const PASSPORT_DATE_START = 'Дата выдачи';
export const PASSPORT_DATE_END = 'Дата окончания';
export const PASSPORT_IDENTIFICATION = 'Идентификационный номер';
export const EMAIL = 'Email';
export const PHONE = 'Телефон';
export const FIRST_NAME_PH = 'Иван';
export const LAST_NAME_PH = 'Иванов';
export const AFTER_NAME_PH = 'Иванович';
export const DATE_PH = 'dd/MM/yyyy';
export const PASSPORT_PH = 'MP1234567';
export const RUS_LETTERS_ERROR = 'Используйте только русские символы.';
export const FIRST_NAME_LAT = 'IVANOV';
export const LAST_NAME_LAT = 'IVAN';
export const LAT_LETTERS_ERROR = 'Используйте только латинские символы.';
export const CITIZENSHIP_PH = 'Беларусь';
export const MALE_SEX = 'Мужской';
export const FEMALE_SEX = 'Женский';
export const SEX = 'Пол';
export const CARD_NUMBER = 'НОМЕР КАРТЫ';
export const CARD_NUMBER_PH = '0000 0000 0000 0000';
export const ONLY_NUMBERS_ERROR = 'Используйте только цифры';
export const CARD_TERM = 'СРОК ДЕЙСТВИЯ';
export const CARD_TERM_MONTH_PH = 'MM';
export const CARD_TERM_YEAR_PH = 'YY';
export const CARD_HOLDER_NAME = 'ИМЯ ВЛАДЕЛЬЦА';
export const CARD_HOLDER_NAME_PH = 'IVAN IVANOV';
export const CARD_CVV = 'CVV/CVC';
export const PRICE_ACTUALIZATION =
  'Цена на тур может измениться. Актуализируем данные по туру через';

export const CONTACT_INFO = 'Контактные данные';
export const BUYER_INFO = 'Информация о покупателе';
export const TOURISTS_INFO = 'Данные туристов';
export const ORDER_INFO = 'Информация о заказе';
export const FILL_DATA = 'Заполните все обязательные поля';
export const PAYMENT_IS_NOT_AVAIL = 'Оплата на данный момент недоступна';
export const NOTE = 'Примечание';
export const TOURISTS_DATA = 'Данные о туристах';
export const FLIGHT = 'Перелет';
export const TOUR_DATA_CHECK = 'Проверка данных';
export const ORDER_NOT_FOUND = 'Заказ не найден';
export const HOTEL = 'Отель';
export const POSTAL_ADDRESS = 'Почтовый адрес';
export const POSTAL_ADDRESS_HINT =
  'По этому адресу мы отправим договор на тур';
export const POST_INDEX = 'Индекс';
export const POST_INDEX_PH = '220000';
export const CITY = 'Населенный пункт';
export const CITY_PH = 'Минск';
export const STREET = 'Улица';
export const STREET_PH = 'пр-т Независимости';
export const HOUSE = 'Дом';
export const HOUSE_PH = '1';
export const FLAT = 'Квартира';
export const FLAT_PH = '1';
export const ONLY_NUMBERS_POST_INDEX_ERROR = 'Индекс состоит из цифр';
export const HOUSE_SHORT = 'д.';
export const FLAT_SHORT = 'кв.';
